import React, { useState, useEffect } from "react";
import Axios from "axios";
import { URL_LIST_ALL } from "../configs/api";
import { useSelector } from "react-redux";
// import MUIDataTable from "mui-datatables";
import Loading from "./Loading";
import { confirmAlert } from "react-confirm-alert";
import { checkRole } from "../model";
import { Table } from "react-bootstrap";
import Pagination from "react-js-pagination";

function List(props) {
  const parsed = window.location.search.replace('?', '');
  let { idrole, name, linkaction, defaultLimit, upload, params, columns, onlyList, noAction, moresearch, refresh, TopBar, listvalue } = props;
  const { user } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(1);
  const [totalResult, setTotalResult] = useState(0);
  const limit = defaultLimit ? defaultLimit : 10;
  const [totalRecord, setTotalRecord] = useState(defaultLimit ? defaultLimit : 10);
  const [change, setChange] = useState(false);
  const allowAdd = checkRole(user, idrole, 'add');
  const allowEdit = checkRole(user, idrole, 'edit');
  const allowDelete = checkRole(user, idrole, 'delete');
  const allowUpload = checkRole(user, idrole, 'upload');
  const allowView = checkRole(user, idrole, 'view');
  const allowAccept = checkRole(user, idrole, 'approve');
  const allowExport = checkRole(user, idrole, 'export');
  const allowImport = checkRole(user, idrole, 'import');

  // const allowRoles = checkRole(user, idrole, 'roles');
  //console.log(parsed)
  useEffect(
    function () {
      let mounted = true;
      if (mounted) {
        setRows([]);
        setLoading(true)
      }
      let config = {
        headers: {
          'Authorization': 'Bearer ' + user.access_token,
          'Content-Type': 'application/json; charset=UTF-8',
          'search': JSON.stringify(moresearch)
        }
      }
      Axios.get(URL_LIST_ALL + name + "?&page=" + page + "&limit=" + limit + (params ? '&' + params : '') + (parsed ? '&' + parsed : ''), config)
        .then((res) => {
          setLoading(false)
          if (res.data.status == "success") {
            setRows(res.data.data);
            setTotalResult(res.data.total)
            if (listvalue) listvalue(res.data)
            setTotalRecord(res.data.total);
          } else console.log(res.data.message);
        })
        .catch((err) => {
          console.log(err);

          if (mounted) setLoading(false)
        });
      return () => (mounted = false);
    },
    [name, change, user, page, limit, params, parsed, moresearch, refresh]
  );

  const actionDelete = (id) => {
    confirmAlert({
      title: "Thông báo",
      message: "Bạn có chắc muốn xoá dữ liệu",
      buttons: [
        {
          label: "Có",
          onClick: () => {
            Axios.delete(URL_LIST_ALL + name + '/' + id, user.config).then(res => {
              if (res.data.status === "success") {
                setChange(!change);
              } else alert(res.data.message);
            }).catch(err => console.log(err));
          },
        },
        { label: "Không" },
      ],
    });
  }


  return (
    <>
      <div className="w-100 d-flex justify-content-between">
        {totalResult ? "Tìm được tổng: " + totalResult + " dữ liệu" : ""}
        {loading && (<Loading />)}
        {!onlyList && <div className="d-flex justify-content-end mb-3">
          {TopBar && <>{TopBar}</>}
          {allowExport &&
            <a href={"/export-" + (linkaction ? linkaction : name)}
              className="btn btn-info m-2"
              style={{ fontSize: 13, fontWeight: '600', color: "#FFF" }}>
              <i className="fas fa-plus-"></i> Xuất file
            </a>}
          {!noAction && allowAdd &&
            <a href={"/add-" + (linkaction ? linkaction : name)}
              className="btn btn-success m-2"
              style={{ fontSize: 13, fontWeight: '600' }}>
              <i className="fas fa-plus-"></i> Thêm mới
            </a>}
          {!upload && allowUpload &&
            <a href={"/upload-" + (linkaction ? linkaction : name)}
              className="btn btn-info m-2"
              style={{ fontSize: 13, fontWeight: '600', color: "#FFF" }}>
              <i className="fas fa-plus-"></i> Upload
            </a>}
          {allowImport &&
            <a href={"/import-" + (linkaction ? linkaction : name)}
              className="btn btn-info m-2"
              style={{ fontSize: 13, fontWeight: '600', color: "#FFF" }}>
              <i className="fas fa-plus-"></i> Import
            </a>}
        </div>}
      </div>
      {/* {children} */}

      {columns && columns.length > 0 &&
        <>
          <Table striped bordered hover className="d-none d-sm-table">
            <thead>
              <tr>
                {columns.map((item, i) => {
                  return <th key={i}>{item.label}</th>
                })}
                {(allowDelete || allowEdit || allowView || allowAccept) && <td>Thao tác</td>}
                {name === 'baocaochamcong' &&
                  <th>#</th>
                }
              </tr>
            </thead>
            <tbody>
              {rows && rows.length > 0 && rows.map((itemTr, iTr) => {
                // let idrow = itemTr.id;
                return (
                  <tr key={iTr}>
                    {columns.map((itemTd, iTd) => {
                      let result = itemTr[itemTd.name]
                      if (itemTd.options && itemTd.options.customBodyRender) {
                        const renderedValue = itemTd.options.customBodyRender(itemTr[itemTd.name], itemTr);
                        result = (renderedValue);
                      }
                      return <td key={iTd}>{result}</td>
                    })}

                    {(allowEdit || allowDelete || allowView || allowAccept) &&
                      <td>
                        {allowEdit && <a href={"/edit-" + (linkaction ? linkaction : name) + "/" + itemTr.id} className="btn btn-sm btn-warning m-1" data-toggle="tooltip" data-placement="bottom" title="Sửa"><i className="fas fa-pencil-alt"></i></a>}
                        {allowDelete && <button className="btn btn-sm btn-danger m-1" onClick={() => actionDelete(itemTr.id)} data-toggle="tooltip" data-placement="bottom" title="Xóa"><i className="fas fa-trash-alt"></i></button>}
                        {allowView && name !== 'users_onday' && <a href={"/view-" + (linkaction ? linkaction : name) + "/" + itemTr.id} className="btn btn-sm btn-warning m-1" data-toggle="tooltip" data-placement="bottom" title="Xem"><i className="fas fa-eye"></i></a>}
                        {allowAccept && <a href={"/approve-" + (linkaction ? linkaction : name) + "/" + itemTr.id} className="btn btn-sm btn-success m-1" data-toggle="tooltip" data-placement="bottom" title="Phê duyệt">Xem</a>}
                      </td>
                    }
                  </tr>
                )
              })
              }
            </tbody>
          </Table>
          <div className="d-block d-sm-none table-mobile">
            <div className="w-100 list">
              {rows && rows.length > 0 && rows.map((itemTr, iTr) => {
                // let idrow = itemTr.id;
                return (
                  <div className="list-item shadow" key={iTr}>
                    {columns.map((itemTd, iTd) => {
                      let result = itemTr[itemTd.name]
                      if (itemTd.options && itemTd.options.customBodyRender) {
                        const renderedValue = itemTd.options.customBodyRender(itemTr[itemTd.name], itemTr);
                        result = (renderedValue);
                      }
                      return <div className="w-100 d-row d-flex" key={iTd}>
                        <div className="item-left" >{itemTd.label}</div>
                        <div className="item-right">{result}</div>
                      </div>
                    })}

                    {(allowEdit || allowDelete || allowView || allowAccept) &&
                      <div className="w-100 d-row d-flex justify-content-center">
                        {allowEdit && <a href={"/edit-" + (linkaction ? linkaction : name) + "/" + itemTr.id} className="btn btn-sm btn-warning m-1" data-toggle="tooltip" data-placement="bottom" title="Sửa"><i className="fas fa-pencil-alt"></i> Sửa</a>}
                        {allowDelete && <button className="btn btn-sm btn-danger m-1" onClick={() => actionDelete(itemTr.id)} data-toggle="tooltip" data-placement="bottom" title="Xóa"><i className="fas fa-trash-alt"></i> Xóa</button>}
                        {allowView && name !== 'users_onday' && <a href={"/view-" + (linkaction ? linkaction : name) + "/" + itemTr.id} className="btn btn-sm btn-warning m-1" data-toggle="tooltip" data-placement="bottom" title="Xem"><i className="fas fa-eye"></i> Xem</a>}
                        {allowAccept && <a href={"/approve-" + (linkaction ? linkaction : name) + "/" + itemTr.id} className="btn btn-sm btn-success m-1" data-toggle="tooltip" data-placement="bottom" title="Phê duyệt"> Phê duyệt</a>}
                      </div>
                    }
                  </div>
                )
              })
              }
            </div>
          </div>
          <div className="w-100 d-flex justify-content-center mt-2 mb-2">
            <Pagination
              activePage={page}
              itemsCountPerPage={limit}
              totalItemsCount={totalRecord}
              pageRangeDisplayed={5}
              itemClass="page-item"
              linkClass="page-link"
              prevPageText="<"
              nextPageText=">"
              onChange={setPage}
            />
          </div>

          <div className="col-12 p-5"></div>
        </>
      }
    </>
  );
}
export default React.memo(List)
//https://github.com/gregnb/mui-datatables